var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyPendant({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 512,
      width: 512
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 32c0 51.5 29.1 108.6 66 153.7 9.8 11.9 20.1 23 30.6 32.8-.4 1.8-.6 3.6-.6 5.5 0 13.7 11.3 25 25 25 4 0 7.8-1 11.1-2.7 14.9 9.5 29.7 16 43.9 18V280c-18.2 4.2-32 20.6-32 40s13.8 35.8 32 40v120h18v-14h39v-18h-39v-18h23v-18h-23v-52c18.2-4.2 32-20.6 32-40s-13.8-35.8-32-40v-15.7c14.2-2 29-8.5 43.9-18 3.3 1.7 7.1 2.7 11.1 2.7 13.7 0 25-11.3 25-25 0-1.9-.2-3.7-.6-5.5 10.5-9.8 20.8-20.9 30.6-32.8 36.9-45.1 66-102.2 66-153.7h-18c0 44.5-26.9 99.4-62 142.3-8.6 10.5-17.7 20.3-26.9 29.1-4-2.8-8.9-4.4-14.1-4.4-13.7 0-25 11.3-25 25 0 3.1.6 6 1.6 8.8C281.3 242 266.9 247 256 247c-10.9 0-25.3-5-40.6-14.2 1-2.8 1.6-5.7 1.6-8.8 0-13.7-11.3-25-25-25-5.2 0-10.1 1.6-14.1 4.4-9.2-8.8-18.3-18.6-26.9-29.1C115.9 131.4 89 76.5 89 32H71zm176 266.8V314h18v-15.2c8.3 3.5 14 11.6 14 21.2 0 12.8-10.2 23-23 23s-23-10.2-23-23c0-9.6 5.7-17.7 14-21.2z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyPendant);
export default __webpack_public_path__ + "static/media/key_pendant.3f95ac98e1d18749a3b08660f0839f6f.svg";
export { ForwardRef as ReactComponent };